import { QuestionCore } from '../../types'

export const TAALBEGRIP_QUESTIONS: QuestionCore[] = [
  // STOFFELIJK BIJVOEGLIJK NAAMWOORD (Existing 12 questions)
  {
    id: 'TAAL-STOF-L1-001',
    module: 'Taalbegrip',
    difficulty: 1,
    question:
      'Welk woord is een stoffelijk bijvoeglijk naamwoord? "Een houten tafel"',
    options: ['houten', 'tafel', 'een', 'geen van deze'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L1-002',
    module: 'Taalbegrip',
    difficulty: 1,
    question:
      'Welk woord is een stoffelijk bijvoeglijk naamwoord? "Een gouden ring"',
    options: ['gouden', 'ring', 'een', 'geen van deze'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L1-003',
    module: 'Taalbegrip',
    difficulty: 1,
    question:
      'Welk woord vertelt van welke stof iets gemaakt is? "Een stenen muur"',
    options: ['stenen', 'muur', 'een', 'alle woorden'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L1-004',
    module: 'Taalbegrip',
    difficulty: 1,
    question: 'Vul in: Een ... deur (van hout)',
    options: ['houten', 'houte', 'houts', 'houten deur'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L2-001',
    module: 'Taalbegrip',
    difficulty: 2,
    question: 'Welke zin heeft een stoffelijk bijvoeglijk naamwoord?',
    options: [
      'De ijzeren poort is zwaar.',
      'De grote poort is zwaar.',
      'De poort is zwaar.',
      'De zware poort staat open.',
    ],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L2-002',
    module: 'Taalbegrip',
    difficulty: 2,
    question:
      'Vul het juiste stoffelijke bijvoeglijk naamwoord in: Een ... lepel (van zilver)',
    options: ['zilveren', 'zilver', 'zilvere', 'zilvers'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L2-003',
    module: 'Taalbegrip',
    difficulty: 2,
    question: 'Welk woord is GEEN stoffelijk bijvoeglijk naamwoord?',
    options: ['mooie', 'houten', 'gouden', 'stenen'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L2-004',
    module: 'Taalbegrip',
    difficulty: 2,
    question: 'Van welke stof is dit gemaakt? "Een wollen trui"',
    options: ['wol', 'katoen', 'zijde', 'leer'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L3-001',
    module: 'Taalbegrip',
    difficulty: 3,
    question:
      'Hoeveel stoffelijke bijvoeglijke naamwoorden staan er in deze zin? "De houten tafel met de ijzeren poten staat op de stenen vloer."',
    options: ['3', '2', '1', '4'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L3-002',
    module: 'Taalbegrip',
    difficulty: 3,
    question: 'Welke zin is FOUT geschreven?',
    options: [
      'Een goud ring ligt op tafel.',
      'Een gouden ring ligt op tafel.',
      'De ring is van goud.',
      'Goud is een kostbaar metaal.',
    ],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L3-003',
    module: 'Taalbegrip',
    difficulty: 3,
    question:
      'Maak de zin af met een stoffelijk bijvoeglijk naamwoord: "De ... beker glinstert in het zonlicht."',
    options: ['zilveren', 'mooie', 'grote', 'volle'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-STOF-L3-004',
    module: 'Taalbegrip',
    difficulty: 3,
    question:
      'Welk paar woorden bestaat uit een stof en het bijbehorende stoffelijke bijvoeglijk naamwoord?',
    options: ['glas - glazen', 'groot - grote', 'mooi - mooie', 'rood - rode'],
    correctAnswer: 0,
  },

  // NIEUW: BIJVOEGLIJKE NAAMWOORDEN (ALGEMEEN)
  {
    id: 'TAAL-BN-L1-001',
    module: 'Taalbegrip',
    difficulty: 1,
    question:
      'Welk woord is het bijvoeglijk naamwoord? "De rode auto rijdt snel."',
    options: ['rode', 'auto', 'rijdt', 'snel'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-BN-L1-002',
    module: 'Taalbegrip',
    difficulty: 1,
    question:
      'Welk woord is het bijvoeglijk naamwoord? "Het lieve hondje blaft."',
    options: ['lieve', 'hondje', 'blaft', 'het'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-BN-L2-001',
    module: 'Taalbegrip',
    difficulty: 2,
    question: 'Vul het juiste woord in: "De ... jongen helpt zijn oma."',
    options: ['aardige', 'aardig', 'aardiger', 'aardigst'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-BN-L2-002',
    module: 'Taalbegrip',
    difficulty: 2,
    question:
      'Hoeveel bijvoeglijke naamwoorden staan er in deze zin? "De oude man loopt met een kromme stok."',
    options: ['2', '1', '3', '0'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-BN-L3-001',
    module: 'Taalbegrip',
    difficulty: 3,
    question: 'Welk woord is GEEN bijvoeglijk naamwoord?',
    options: ['lopen', 'mooi', 'groot', 'klein'],
    correctAnswer: 0,
  },

  // NIEUW: ZELFSTANDIGE NAAMWOORDEN
  {
    id: 'TAAL-ZN-L1-001',
    module: 'Taalbegrip',
    difficulty: 1,
    question:
      'Welk woord is een zelfstandig naamwoord? "De kat slaapt op de bank."',
    options: ['kat', 'slaapt', 'op', 'de'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-ZN-L1-002',
    module: 'Taalbegrip',
    difficulty: 1,
    question:
      'Welk woord is een zelfstandig naamwoord? "Ik eet een lekkere appel."',
    options: ['appel', 'eet', 'lekkere', 'ik'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-ZN-L2-001',
    module: 'Taalbegrip',
    difficulty: 2,
    question: 'Welk woord is een mens, dier of ding?',
    options: ['fiets', 'fietsen', 'snel', 'naar'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-ZN-L2-002',
    module: 'Taalbegrip',
    difficulty: 2,
    question:
      'Hoeveel zelfstandige naamwoorden staan er in deze zin? "De bakker bakt brood in de oven."',
    options: ['3', '2', '4', '1'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-ZN-L3-001',
    module: 'Taalbegrip',
    difficulty: 3,
    question: 'Welk woord is een eigennaam (naam van een persoon of plaats)?',
    options: ['Amsterdam', 'stad', 'groot', 'wonen'],
    correctAnswer: 0,
  },

  // NIEUW: WERKWOORDEN HERKENNEN
  {
    id: 'TAAL-WW-L1-001',
    module: 'Taalbegrip',
    difficulty: 1,
    question: 'Wat is het werkwoord (doe-woord)? "Wij rennen naar school."',
    options: ['rennen', 'wij', 'naar', 'school'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-WW-L2-001',
    module: 'Taalbegrip',
    difficulty: 2,
    question: 'Welk woord is GEEN werkwoord?',
    options: ['tafel', 'lopen', 'zwemmen', 'denken'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-WW-L2-002',
    module: 'Taalbegrip',
    difficulty: 2,
    question:
      'Wat is de persoonsvorm in deze zin? "Gisteren fietste ik naar huis."',
    options: ['fietste', 'gisteren', 'ik', 'huis'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-WW-L3-001',
    module: 'Taalbegrip',
    difficulty: 3,
    question:
      'Hoeveel werkwoorden staan er in deze zin? "Ik heb gisteren lekker gezwommen."',
    options: ['2', '1', '3', '0'],
    correctAnswer: 0,
  },

  // NIEUW: LIDWOORDEN
  {
    id: 'TAAL-LW-L1-001',
    module: 'Taalbegrip',
    difficulty: 1,
    question: 'Vul in: ... huis is groot.',
    options: ['Het', 'De', 'Een', 'Die'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-LW-L2-001',
    module: 'Taalbegrip',
    difficulty: 2,
    question: 'Welk lidwoord hoort bij "tafel"?',
    options: ['de', 'het', 'een', 'geen'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-LW-L2-002',
    module: 'Taalbegrip',
    difficulty: 2,
    question: 'Welk lidwoord hoort bij "boek"?',
    options: ['het', 'de', 'een', 'geen'],
    correctAnswer: 0,
  },
  {
    id: 'TAAL-LW-L3-001',
    module: 'Taalbegrip',
    difficulty: 3,
    question: 'Welk woord is een onbepaald lidwoord?',
    options: ['een', 'de', 'het', 'die'],
    correctAnswer: 0,
  },
]
